import { render, staticRenderFns } from "./SwiperSlider.vue?vue&type=template&id=6d6e4174&"
import script from "./SwiperSlider.vue?vue&type=script&lang=js&"
export * from "./SwiperSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports